<template>
  <div>
    <PageTitle title="Edit Waiter" :backBtn="true" :showLoading="isLoading" />
    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <v-container fluid class="lighten-12 content">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="12">
                <v-card class="lighten-12 card-content mb-1">
                  <v-card-title> General</v-card-title>

                  <v-container fluid class="light gray lighten-12">
                    <form>
                      <v-row>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <ValidationProvider
                            v-slot="{ errors }"
                            vid="first_name"
                            name="Name"
                            rules="required|no_spaces_only"
                          >
                            <v-text-field
                              outlined
                              dense
                              v-model="waiter.name"
                              :error-messages="errors"
                              label="Name"
                              hide-details="auto"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" sm="6" md="12" lg="12">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Description"
                          >
                            <v-textarea
                              hide-details="auto"
                              outlined
                              dense
                              rows="2"
                              v-model="waiter.remarks"
                              :error-messages="errors"
                              label="Description"
                              required
                            ></v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </form>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-card class="lighten-12 card-content">
                  <v-card-title> Address</v-card-title>
                  <v-container>
                    <!-- {{waiter.address}} -->
                    <AddressComponent
                      ref="addressComponent"
                      :address="waiter.address"
                    />
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="lighten-12 card-content" height="100%">
                  <v-card-title> Contact</v-card-title>
                  <v-container fluid class="light gray lighten-12">
                    <v-row>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="{ regex: /^(0\d{9}|\+94\d{9})$/ }"
                        >
                          <v-text-field
                            hide-details="auto"
                            dense
                            outlined
                            maxlength="12"
                            v-model="waiter.contact.telephone"
                            :error-messages="errors"
                            label="Telephone"
                            required
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="{
                            required: true,
                            regex: /^(0\d{9}|\+94\d{9})$/,
                          }"
                        >
                          <v-text-field
                            dense
                            outlined
                            v-model="waiter.contact.phone"
                            :error-messages="errors"
                            label="phone"
                            maxlength="12"
                            required
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Email"
                          vid="email"
                          rules="email"
                        >
                          <v-text-field
                            outlined
                            dense
                            hide-details="auto"
                            v-model="waiter.contact.email"
                            :error-messages="errors"
                            label="E-mail"
                            required
                          ></v-text-field>
                          <!-- <ServerMessages dense name="email" /> -->
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click="clear"
            depressed
            small
            class="ml-1 text-white btn_medium"
            >clear</v-btn
          >
          <v-btn
            @click="submit"
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            >submit</v-btn
          >
        </v-card-actions>
      </v-container>
    </ValidationObserver>

    <v-container>
      <v-card>
        <v-card-title>Waiter app</v-card-title>
        <v-card-text v-if="appAccess.linked">
          {{ waiter.name || "This waiter" }} can sign in to the waiter app as
          <strong>{{ appAccess.user.username }}</strong>.
          They still appear on the KOT waiter list.
        </v-card-text>
        <v-card-text v-else>
          <p class="mb-4">
            Give this KOT waiter a login for the waiter app. They stay on the KOT waiter list.
          </p>
          <ValidationObserver ref="appObserver">
            <v-row>
              <v-col cols="12" sm="6">
                <ValidationProvider v-slot="{ errors }" name="Username" rules="required">
                  <v-text-field
                    dense
                    outlined
                    v-model="appLogin.username"
                    :error-messages="errors"
                    label="Username"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6">
                <ValidationProvider v-slot="{ errors }" name="Role" rules="required">
                  <v-select
                    dense
                    outlined
                    v-model="appLogin.roles"
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors"
                    label="Role"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6">
                <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                  <v-text-field
                    dense
                    outlined
                    v-model="appLogin.email"
                    :error-messages="errors"
                    label="E-mail"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6">
                <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                  <v-text-field
                    dense
                    outlined
                    v-model="appLogin.phone"
                    :error-messages="errors"
                    label="Phone"
                    maxlength="12"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-btn
              depressed
              small
              class="text-white btn_blue btn_medium"
              :disabled="appSaving"
              :loading="appSaving"
              @click="grantAppAccess"
            >
              Give waiter app access
            </v-btn>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import jwt_decode from "jwt-decode";
import { mapGetters } from "vuex";

import { Waiter } from "../../../models/Waiter";

import { WaiterViewModel } from "../../../models/View Models/WaiterViewModel";
import AddressComponent from "../../shared/components/Address";
import FileUpload from "@/components/base/FileUpload";
import ChangePassword from "../../../components/shared/ChangePassword";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { Contact } from "../../../models/Contact";
import axios from "@/plugins/axios";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});
extend("regex", {
  ...regex,
  message: "The value is not a valid phone number",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    AddressComponent,
    FileUpload,
    ChangePassword,
  },
  data: () => ({
    checkbox: null,
    waiter: new Waiter(),

    isLoading: false,
    errors: [],

    messages: [],
    roles: [],
    appSaving: false,
    appAccess: { linked: false, user: null },
    appLogin: {
      username: "",
      email: "",
      phone: "",
      roles: null,
    },
  }),
  computed: {
    ...mapGetters("waiter", ["Getwaiters"]),
  },
  created() {
    this.GetSingleWaiterDetail();
    this.GetRoles();
    this.loadAppAccess();
  },

  methods: {
    UpdateWaiter() {
      this.isLoading = true;
      this.isDisabledSubmit = true;

      this.$store
        .dispatch("waiter/EditWaiter", new Waiter().ToRequestModel(this.waiter))
        .then((res) => {
          this.succeeed = true;

          this.isDisabledSubmit = false;
          this.$router.push("/waiter");
          this.$toast.success("Waiter added  successfully");
          this.isLoading = false;
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.messages = err.data.title;
          this.isLoading = false;
          this.isDisabledSubmit = false;
          this.$toast.error("Waiter creation failed");
          // this.isDisabledSubmit = false;
        });
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.UpdateWaiter();
      } else if (isValid) {
      }
    },
  clear() {
  this.$refs.observer.reset();   
  this.waiter = new Waiter();  
},

    GetSingleWaiterDetail() {
      let WaiterId = this.$route.params.id;
      this.$store
        .dispatch("waiter/GetSingleWaiter", WaiterId)
        .then((res) => {
          this.waiter = new WaiterViewModel(res.data);
          if (!this.appLogin.email && this.waiter.contact) {
            this.appLogin.email = this.waiter.contact.email || "";
            this.appLogin.phone = this.waiter.contact.phone || "";
          }
          if (!this.appLogin.username && this.waiter.name) {
            this.appLogin.username = String(this.waiter.name)
              .toLowerCase()
              .replace(/[^a-z0-9]/g, "");
          }
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    GetRoles() {
      this.$store.dispatch("GetRoles").then((res) => {
        this.roles = res.data || [];
      });
    },
    loadAppAccess() {
      axios
        .get(`hms/waiters/${this.$route.params.id}/app-access`)
        .then((res) => {
          this.appAccess = res.data || { linked: false, user: null };
        })
        .catch(() => {
          this.appAccess = { linked: false, user: null };
        });
    },
    async grantAppAccess() {
      const isValid = await this.$refs.appObserver.validate();
      if (!isValid) return;
      this.appSaving = true;
      axios
        .post(`hms/waiters/${this.$route.params.id}/app-access`, this.appLogin)
        .then((res) => {
          this.appSaving = false;
          this.appAccess = {
            linked: true,
            user: {
              username: this.appLogin.username,
              email: this.appLogin.email,
            },
          };
          if (res.data && res.data.email_status) {
            this.$toast.success("Waiter app login created and emailed");
          } else {
            this.$toast.success(
              "Waiter app login created. Email was not sent, so reset the password from Users."
            );
          }
        })
        .catch((err) => {
          this.appSaving = false;
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            "Could not give waiter app access";
          this.$toast.error(message);
        });
    },
  },
};
</script>

<style scoped>
/* .btnRightMargin {
  margin-right: 10px;
}

.container {
  color: white !important;
}
.form-blue {
  background: #d8dbe0;
  border-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.messages {
  border: transparent !important;
  margin-right: 40px;
} */
</style>
